<script scoped>
import axios from "axios";
import Datatable from "@/router/layouts/table-datatable.vue";
import ModalEditBatchTimer from "./modal-edit-batch-timer.vue";
import Swal from "sweetalert2";

export default {
  props: ["idjadwal", "idjadwal_batch"],
  components: {
    Datatable,
    ModalEditBatchTimer,
  },
  data() {
    let columns = [
      {
        width: "50px",
        label: "No",
        name: "-",
      },
      {
        width: "auto",
        label: "Level",
        name: "-",
      },
      {
        width: "auto",
        label: "Output Timer",
        name: "-",
      },
      {
        width: "auto",
        label: "Output Pilihan Ganda",
        name: "-",
      },
      {
        width: "auto",
        label: "Output Benar Salah",
        name: "-",
      },
      {
        width: "auto",
        label: "Output Menjodohkan",
        name: "-",
      },
      {
        width: "auto",
        label: "Output Pilihan Ganda Studi Kasus",
        name: "-",
      },
      {
        width: "auto",
        label: "Output Benar Salah Studi Kasus",
        name: "-",
      },
      {
        width: "auto",
        label: "Output Esai",
        name: "-",
      },
      {
        width: "auto",
        label: "Aksi",
        name: "-",
      }, // jika tidak ada sorting kasih name dengan karakter -
    ];
    return {
      columns: columns,
      table_data: [],
      loadingTable: true,
      selected_row: {},
      showModalEditBatchTimer: false,
      batchId: this.idjadwal_batch,
      jadwalId: this.idjadwal,
    };
  },
  methods: {
    getDataTable() {
      this.loadingTable = true;
      let config = {
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          `master/jadwal-pelaksanaan/${this.idjadwal}/setup-jadwal/batch/${this.idjadwal_batch}/timer`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
      };
      axios(config)
        .then((response) => {
          this.loadingTable = false;
          this.table_data = response.data.data;
          console.log("Data fetched successfully:", this.table_data);
        })
        .catch((error) => {
          this.loadingTable = false;
          console.error("Error fetching data:", error);
        });
    },
    editTresholdNilai(item) {
      console.log(this.idjadwal, this.idjadwal_batch, item);
      this.selected_row = item;
      this.showModalEditBatchTimer = true;
    },
    reset(row) {
      Swal.fire({
        title: "Konfirmasi",
        text: "Apakah Anda yakin ingin mengatur ulang timer dan jumlah soal batch ini?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Iya",
        cancelButtonText: "Batal",
      }).then((result) => {
        if (result.isConfirmed) {
          if (row.idjadwal_batch_timer == null) {
            Swal.fire({
              icon: "success",
              title: "Berhasil",
              text: "Data berhasil diatur ulang.",
            });
            return;
          }

          this.loadingTable = true;
          let config = {
            method: "delete",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              `master/jadwal-pelaksanaan/${this.jadwalId}/setup-jadwal/batch/${this.batchId}/timer/${row.idjadwal_batch_timer}`,
            headers: {
              Accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          };
          axios(config)
            .then((response) => {
              console.log("Data reset successfully:", response.data);
              this.getDataTable();
              Swal.fire({
                icon: "success",
                title: "Berhasil",
                text: "Timer dan jumlah soal berhasil direset.",
              });
            })
            .catch((error) => {
              console.error("Error resetting data:", error);
              Swal.fire({
                icon: "error",
                title: "Gagal",
                text: "Terjadi kesalahan saat mereset data.",
              });
            })
            .finally(() => {
              this.loadingTable = false;
            });
        }
      });
    },
  },
  mounted() {
    this.getDataTable();
  },
};
</script>

<template>
  <div class="row">
    <div class="col">
      <div class="card-title">Konfigurasi Timer dan Jumlah Soal Batch</div>
    </div>
    <div class="mt-2">
      <datatable :columns="columns">
        <tbody>
          <tr v-if="loadingTable">
            <td colspan="10" class="text-center">
              <!-- <div class="spinner-border text-primary" role="status">
                <span class="sr-only">Loading...</span>
              </div> -->
              <i class="fas fa-spinner fa-spin"></i> Loading...
            </td>
          </tr>
          <tr v-else-if="table_data.length == 0">
            <td colspan="10" class="text-center">Data tidak ditemukan</td>
          </tr>
          <tr v-else v-for="(item, index) in table_data" :key="index">
            <td class="text-center">{{ index + 1 }}</td>
            <td>
              {{ item.level.nama_level }}
            </td>
            <td>{{ item.timer ?? 0 }} menit</td>
            <td>
              {{ item.output_soal_pg ?? 0 }}
            </td>
            <td>
              {{ item.output_soal_bs ?? 0 }}
            </td>
            <td>
              {{ item.output_soal_mj ?? 0 }}
            </td>
            <td>
              {{ item.output_soal_pgsk ?? 0 }}
            </td>
            <td>
              {{ item.output_soal_bssk ?? 0 }}
            </td>
            <td>
              {{ item.output_soal_text ?? 0 }}
            </td>
            <td>
              <div class="btn-group btn-sm">
                <button
                  class="btn btn-warning btn-sm"
                  @click="editTresholdNilai(item)"
                >
                  <i class="fa fa-edit"></i>
                  Edit
                </button>
                <button class="btn btn-danger btn-sm" @click="reset(item)">
                  <i class="fa fa-undo"></i>
                  Reset
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </datatable>
    </div>
  </div>

  <b-modal
    v-model="showModalEditBatchTimer"
    hide-footer
    :title="
      `Edit Timer dan Jumlah Soal Level ` + selected_row?.level?.nama_level
    "
  >
    <ModalEditBatchTimer
      :selectedData="selected_row"
      @close="showModalEditBatchTimer = false"
      @submitBatchTimer="
        getDataTable();
        showModalEditBatchTimer = false;
      "
    ></ModalEditBatchTimer>
  </b-modal>
</template>
